import { render, staticRenderFns } from "./tablaColores.vue?vue&type=template&id=53a40208&scoped=true&"
import script from "./tablaColores.vue?vue&type=script&lang=js&"
export * from "./tablaColores.vue?vue&type=script&lang=js&"
import style0 from "./tablaColores.vue?vue&type=style&index=0&id=53a40208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a40208",
  null
  
)

export default component.exports